"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ChariotResourceFactory_1 = require("./ChariotResourceFactory");
var graphql_request_1 = require("graphql-request");
var models_1 = require("../models");
var memoizable_1 = require("../../helpers/memoizable");
var Errors_1 = require("../../helpers/Errors");
var notificationSelectionSet = "{ \n  email_list\n  flightdeck\n  sms_list\n}";
var criteriaSelectionSet = "{\n  id\n  labels\n}";
var pointSelectorSelectionSet = "{ \n  equipment ".concat(criteriaSelectionSet, "\n  point ").concat(criteriaSelectionSet, "\n  site ").concat(criteriaSelectionSet, "\n}");
var conditionSelectionSet = "{\n  source ".concat(pointSelectorSelectionSet, "\n  target ").concat(pointSelectorSelectionSet, "\n  type\n  value\n}");
var parentConditionSelectionSet = "{\n  children ".concat(conditionSelectionSet, "\n  source ").concat(pointSelectorSelectionSet, "\n  target ").concat(pointSelectorSelectionSet, "\n  type\n  value\n}");
var RuleFactory = /** @class */ (function (_super) {
    __extends(RuleFactory, _super);
    function RuleFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultSelectionSet = "{\n    id\n    conditions ".concat(parentConditionSelectionSet, "\n    grace\n    name\n    notification ").concat(notificationSelectionSet, "\n    owner\n    priority\n    enabled\n    users\n  }");
        return _this;
    }
    RuleFactory.prototype.build = function (apiRule) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!!apiRule.client_id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.chariot.waitForLogin()];
                    case 1:
                        _a.sent();
                        apiRule.client_id = this.chariot.getClient()._.id || "";
                        _a.label = 2;
                    case 2: return [2 /*return*/, new models_1.Rule(apiRule, this.chariot)];
                    case 3:
                        e_1 = _a.sent();
                        this.chariot.logger.catch(e_1, "Failed to build rule");
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RuleFactory.prototype.list = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, filters, getAsAdmin, _c, selectionSet, response, rules, e_2;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 3, , 4]);
                        _a = options || {}, _b = _a.filters, filters = _b === void 0 ? {} : _b, getAsAdmin = _a.getAsAdmin, _c = _a.selectionSet, selectionSet = _c === void 0 ? this.defaultSelectionSet : _c;
                        if (!(this.chariot.options.noClientBoundaries || getAsAdmin)) {
                            filters.client_id = this.chariot.getClient()._.id;
                        }
                        return [4 /*yield*/, this.chariot.GraphQL.request({
                                query: (0, graphql_request_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          query rules($input: ListRuleInput) {\n            rules(input: $input) ", "\n          }\n        "], ["\n          query rules($input: ListRuleInput) {\n            rules(input: $input) ", "\n          }\n        "])), selectionSet),
                                variables: {
                                    input: filters
                                }
                            })];
                    case 1:
                        response = (_d.sent()).rules;
                        return [4 /*yield*/, Promise.all(response.map(function (r) { return _this.build(r); }))];
                    case 2:
                        rules = _d.sent();
                        return [2 /*return*/, rules];
                    case 3:
                        e_2 = _d.sent();
                        this.chariot.logger.catch(e_2, "Failed to list rules");
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RuleFactory.prototype.iterate = function (options) {
        return __asyncGenerator(this, arguments, function iterate_1() {
            var _a, filters, _b, selectionSet, rules, apiRuleIterator, _i, apiRuleIterator_1, apiRule, rule, e_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 9, , 10]);
                        _a = options || {}, filters = _a.filters, _b = _a.selectionSet, selectionSet = _b === void 0 ? this.defaultSelectionSet : _b, rules = [];
                        return [4 /*yield*/, __await(this.chariot.GraphQL.request({
                                query: (0, graphql_request_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          query rules($input: ListRuleInput) {\n            rules(input: $input) ", "\n          }\n        "], ["\n          query rules($input: ListRuleInput) {\n            rules(input: $input) ", "\n          }\n        "])), selectionSet),
                                variables: {
                                    input: filters
                                }
                            }))];
                    case 1:
                        apiRuleIterator = (_c.sent()).rules;
                        _i = 0, apiRuleIterator_1 = apiRuleIterator;
                        _c.label = 2;
                    case 2:
                        if (!(_i < apiRuleIterator_1.length)) return [3 /*break*/, 7];
                        apiRule = apiRuleIterator_1[_i];
                        return [4 /*yield*/, __await(this.build(apiRule))];
                    case 3:
                        rule = _c.sent();
                        rules.push(rule);
                        return [4 /*yield*/, __await(rule)];
                    case 4: return [4 /*yield*/, _c.sent()];
                    case 5:
                        _c.sent();
                        _c.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 2];
                    case 7: return [4 /*yield*/, __await(rules)];
                    case 8: return [2 /*return*/, _c.sent()];
                    case 9:
                        e_3 = _c.sent();
                        this.chariot.logger.catch(e_3, "Failed to iterate rules");
                        throw e_3;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    RuleFactory.prototype.get = function (ruleId, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, selectionSet, response, e_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        _a = (options || {}).selectionSet, selectionSet = _a === void 0 ? this.defaultSelectionSet : _a;
                        return [4 /*yield*/, this.chariot.GraphQL.request({
                                query: (0, graphql_request_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          query rule($ruleId: String!) {\n            rule(id: $ruleId) ", "\n          }\n        "], ["\n          query rule($ruleId: String!) {\n            rule(id: $ruleId) ", "\n          }\n        "])), selectionSet),
                                variables: { ruleId: ruleId }
                            })];
                    case 1:
                        response = (_b.sent()).rule;
                        if (!response) {
                            throw new Errors_1.EntityNotFoundError();
                        }
                        return [4 /*yield*/, this.build(response)];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3:
                        e_4 = _b.sent();
                        this.chariot.logger.catch(e_4, "Failed to retrieve rule");
                        throw e_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RuleFactory.prototype.find = function (_a) {
        var filters = _a.filters, errorIfMultiple = _a.errorIfMultiple, selectionSet = _a.selectionSet;
        return __awaiter(this, void 0, void 0, function () {
            var rules, e_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.chariot.Rule.list({ filters: filters, selectionSet: selectionSet })];
                    case 1:
                        rules = _b.sent();
                        if (rules.length == 0) {
                            throw new Errors_1.EntityNotFoundError();
                        }
                        else if (rules.length > 1 && errorIfMultiple) {
                            throw new Errors_1.MultipleMatchesError();
                        }
                        return [2 /*return*/, rules[0]];
                    case 2:
                        e_5 = _b.sent();
                        this.chariot.logger.catch(e_5, "Failed to find rule");
                        throw e_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        memoizable_1.memoizable,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], RuleFactory.prototype, "list", null);
    __decorate([
        memoizable_1.memoizable,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Object)
    ], RuleFactory.prototype, "iterate", null);
    __decorate([
        memoizable_1.memoizable,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Promise)
    ], RuleFactory.prototype, "get", null);
    __decorate([
        memoizable_1.memoizable,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], RuleFactory.prototype, "find", null);
    return RuleFactory;
}(ChariotResourceFactory_1.GraphEnabledChariotResourceFactory));
exports.default = RuleFactory;
var templateObject_1, templateObject_2, templateObject_3;
